// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import messageHeartSquareIcon from "@/assets/icons/message-heart-square.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MessageHeartSquareIconProps = Omit<IconProps, "name">;

export function MessageHeartSquareIcon(props: MessageHeartSquareIconProps): React.ReactNode {
  return <Icon name={messageHeartSquareIcon} {...props} />;
}
